// ©2024 Austin App House. All rights reserved.
//
// Generic confirmation modal with a green primary action on the left and a red
// cancel on the right. Driven entirely via toggleModal payload:
//   toggleModal(true, 'confirmActionModal', false, {
//     title, message, confirmLabel, cancelLabel, danger, onConfirm, onCancel,
//   })
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { toggleSecondModalClose } from '../../storage/actions/modalsActions';

const ConfirmActionModal = ({ toggleSecondModalClose, modalState }) => {
  const type = modalState?.type || {};
  const [confirmation, setConfirmation] = useState('');
  const requiresConfirmation = typeof type.confirmationText === 'string';
  const confirmationMatches = !requiresConfirmation || confirmation === type.confirmationText;
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (modalState?.isOpen) {
      setSubmitting(false);
      setConfirmation('');
    }
  }, [modalState?.isOpen]);

  const close = () => {
    if (submitting) return;
    toggleSecondModalClose('confirmActionModal', true);
  };

  const onCancel = () => {
    if (typeof type.onCancel === 'function') type.onCancel();
    close();
  };

  const onConfirm = async () => {
    if (submitting || !confirmationMatches) return;
    setSubmitting(true);
    try {
      await type.onConfirm?.();
      toggleSecondModalClose('confirmActionModal', true);
    } catch (error) {
      setSubmitting(false);
    }
  };

  if (!modalState?.isOpen) return null;

  const confirmLabel = type.confirmLabel || 'Confirm';
  const cancelLabel = type.cancelLabel || 'Cancel';

  return (
    <div
      className="modal_block dashboard-modal dashboard-modal--centered modal_import showed"
      role="presentation"
      onClick={close}
    >
      <div
        className="modal_container"
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal_head">
          <div className="modal_title">{type.title || 'Are you sure?'}</div>
          <button type="button" className="close_btn" aria-label="close" onClick={close}>
            ×
          </button>
        </div>
        <div className="modal_body">
          <div className="modal_content">{type.message}</div>
          {requiresConfirmation && (
            <label htmlFor="confirm-action-name">
              {`Type ${type.confirmationText} to confirm`}
              <input
                id="confirm-action-name"
                type="text"
                value={confirmation}
                onChange={(event) => setConfirmation(event.target.value)}
                disabled={submitting}
                autoComplete="off"
              />
            </label>
          )}
        </div>
        <div className="modal_footer modal_footer--suspend">
          <button
            type="button"
            className={`dashboard-btn dashboard-btn--suspend-confirm${type.danger ? ' dashboard-btn--danger-confirm' : ''}`}
            onClick={onConfirm}
            disabled={submitting || !confirmationMatches}
          >
            {submitting ? `${confirmLabel}…` : confirmLabel}
          </button>
          <button
            type="button"
            className="dashboard-btn dashboard-btn--suspend-cancel"
            onClick={onCancel}
            disabled={submitting}
          >
            {cancelLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  modalState: state.modalState.confirmActionModal,
});

export default connect(mapStateToProps, { toggleSecondModalClose })(ConfirmActionModal);
